import { useTranslation } from 'react-i18next';

const RSVP = () => {
    const { t } = useTranslation();

    return (
        <section id="rsvp" className="animate-fadeInUp">
            <div className="glass-card rsvp-content">
                <h2>{t('rsvp')}</h2>
                <p className="rsvp-text">{t('rsvp_text')}</p>
                <a
                    href="https://forms.gle/7ejeQkkVFvT8CB8Q7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                >
                    {t('rsvp_button')}
                </a>
            </div>
        </section>
    );
};

export default RSVP;
